import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./model.css";
import { v4 as uuid } from "uuid";
import axiosinstances from "../../Helper/useAxios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { isSuperAdmin } from "../../utils/comman/Common";
// import "./addticket.css";

export default function UpdatTicket(props) {
  const { show, handleShow, handleClose, fetchpagedata } = props;
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const [dataLoading, setDataLoading] = useState(false);
  const [searchBy, setSearchBy] = useState("Download");
  const [ticketRequest, setticketRequest] = useState({
    txnId: "",
    service: "",
    operator: "",
    description: "",
    comment: "",
  });
  const [axiosInstance] = axiosinstances();
  const e = JSON.parse(sessionStorage.getItem("token"));

  const ticketChangeHandle = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "txnId") {
      updatedValue = value.replace(/\s+/g, ""); // Removes all spaces
    }

    setticketRequest((pre) => ({ ...pre, [name]: updatedValue.trim() }));
  };

  const handleOperatorClick = (op) => {
    setticketRequest((pre) => ({ ...pre, operator: op }));
  };

  const handleDServiceClick = (op) => {
    setticketRequest((pre) => ({ ...pre, service: op }));
  };
  // console.log("ticketRequest", ticketRequest);
  useEffect(() => {
    setticketRequest({
      txnId: "",
      service: "",
      operator: "",
      description: "",
      comment: "",
    });
  }, [show]);

  const createNewToken = async (e) => {
    e.preventDefault();
    const requestPayload = {
      header: {
        msgType: "STATUS_UPDATE",
        service: "MOBILE",
        src: null,
        dst: null,
        channel: "WHITELABEL",
        requesterId: id,
        requestId: uuid(),
        time: new Date().toISOString(),
        traceId: uuid(),
        hops: null,
      },
      complaint: {
        orderId: ticketRequest?.txnId,
        service: ticketRequest?.service,
        operator: ticketRequest?.operator,
        description: ticketRequest?.description,
        comment: ticketRequest?.comment,
        createdBy: id,
        ip: "127.0.0.1",
      },
    };
    if (ticketRequest?.txnId == "") {
      toast.error("Enter Your txnId");
      return;
    }
    if (ticketRequest?.comment == "") {
      toast.error("Enter Your Comments");
      return;
    }
    if (ticketRequest?.service == "") {
      toast.error("Enter Your service");
      return;
    }
    if (ticketRequest?.operator == "") {
      toast.error("Enter Your operator");
      return;
    }
    // if (ticketRequest?.description == "") {
    //   toast.error("Enter Your description");
    //   return;
    // }

    //userTxnDate
    if (requestPayload?.userTxnDate == "") {
      toast.error("User Txn Date By is not Valid and its required to fill");
      return;
    }

    setDataLoading(true);
    const API_ENDPOINT = "/api/v1/finxpay/complaint/create";
    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers: {
          Authorization: `Bearer ${e}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      });

      if (response.status === 200 && response?.data?.success) {
        toast.success(
          `Your ticket has raised and ref is ${response?.data?.ticketId}`
        );

        setDataLoading(false);
        let url = "";

        if (isSuperAdmin(id)) {
          url = `/api/v1/finxpay/complaint/list?pageNo=1&pageSize=20`;
        } else {
          url = `/api/v1/finxpay/complaint/list?pageNo=1&pageSize=20&createdBy=${id}`;
        }
        fetchpagedata(url);
        setticketRequest({
          txnId: "",
          service: "",
          operator: "",
          description: "",
          comment: "",
        });
        handleClose();
      } else {
        setDataLoading(false);
        throw new Error(response?.response?.data?.message);
      }
    } catch (error) {
      setDataLoading(false);
      console.error("Error fetching data:", error);

      toast.error(error?.message);
      return false;
    }
  };
  const predefinedComments = [
    "Recharge not received",
    "Wrong no. recharge",
    "Plan not showing",
  ];
  console.log(ticketRequest);
  const handleDropdownSelect = (selectedComment) => {
    setticketRequest((pre) => ({ ...pre, comment: selectedComment }));
  };
  const handleDownload = (val) => {
    setSearchBy(val);
  };
  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}>
        Launch modal
    </Button> */}

      <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>Add Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Your modal body content here */}
          <div class="modal-body">
            <div class="container">
              {/* <!-- project  first row --> */}

              {/* <!-- status Secoond row --> */}
              <div class="row">
                <div class="col-12">
                  <div class="project-model">
                    <label for="txnId">
                      TxnId <span class="text-danger">*</span>{" "}
                    </label>
                    <input
                      value={ticketRequest?.txnId}
                      type="text"
                      onChange={ticketChangeHandle}
                      name="txnId"
                      id="txnId"
                      class="form-control border inputbg border-2"
                    />
                  </div>
                </div>

                <div class="col-12">
                  <div class="project-model">
                    <label for="service">
                      Service <span class="text-danger">*</span>{" "}
                    </label>
                    <input
                      value={ticketRequest?.service}
                      type="text"
                      onChange={ticketChangeHandle}
                      name="service"
                      id="service"
                      class="form-control border inputbg border-2"
                    />
                  </div>
                  <div className="mt-2">
                    {["Mobile", "DTH"].map((op) => (
                      <button
                        key={op}
                        className="btn btn-primary m-1"
                        onClick={() => handleDServiceClick(op)}
                      >
                        {op}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="col-12">
                  <div className="project-model">
                    <label htmlFor="operator">
                      Operator <span className="text-danger">*</span>
                    </label>
                    <input
                      value={ticketRequest?.operator}
                      type="text"
                      placeholder="Operator"
                      name="operator"
                      id="operator"
                      onChange={ticketChangeHandle}
                      className="form-control border inputbg border-2"
                      // readOnly
                    />
                  </div>
                  <div className="mt-2">
                    {[
                      "Airtel",
                      "Jio",
                      "Vi",
                      "BSNL",
                      "MTNL",
                      "Tata Play",
                      "Sun Direct",
                      "Dish TV",
                      "D2H",
                    ].map((op) => (
                      <button
                        key={op}
                        className="btn btn-primary m-1"
                        onClick={() => handleOperatorClick(op)}
                      >
                        {op}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="col-12">
                  <div className="project-model">
                    <label htmlFor="comment">
                      Comment <span className="text-danger">*</span>
                    </label>
                    {searchBy === "Text" ? (
                      <input
                        type="text"
                        onChange={ticketChangeHandle}
                        value={ticketRequest?.comment}
                        name="comment"
                        id="comment"
                        className="form-control border inputbg border-2"
                        placeholder="Select or enter a comment"
                      />
                    ) : (
                      <select
                        className="form-control mt-2"
                        onChange={(e) => handleDropdownSelect(e.target.value)}
                      >
                        <option value="">Select a comment</option>
                        {predefinedComments.map((c, index) => (
                          <option key={index} value={c}>
                            {c}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>

                  {/* Download Button */}
                  <button
                    className={`btn btn-${
                      searchBy === "Download" ? "primary" : "secondary"
                    } mt-3`}
                    onClick={() => handleDownload("Download")}
                  >
                    Download
                  </button>

                  <button
                    className={`btn btn-${
                      searchBy === "Text" ? "primary" : "secondary"
                    }  mt-3 ml-4`}
                    onClick={() => handleDownload("Text")}
                  >
                    Text
                  </button>
                </div>
                {/* <div class="col-12">
                  <div class="project-model">
                    <label for="comment">
                      comment <span class="text-danger">*</span>{" "}
                    </label>
                    <input
                      value={ticketRequest?.comment}
                      type="text"
                      onChange={ticketChangeHandle}
                      name="comment"
                      id="comment"
                      class="form-control border inputbg border-2"
                    />
                  </div>
                </div> */}
                <div class="col-12">
                  <div class="project-model">
                    <label for="description">
                      Description
                      {/* <span class="text-danger">*</span>{" "} */}
                    </label>
                    <textarea
                      value={ticketRequest?.description}
                      onChange={ticketChangeHandle}
                      name="description"
                      id="description"
                      className="form-control border inputbg border-2"
                      rows={2} // Adjust the number of visible lines
                    />
                  </div>
                </div>
                {/* <!-- Description --> */}
                {/* <div class="col-12 mb-3">
                    <label for="">
                      Description <span class="text-danger">*</span>
                    </label>
                    <textarea
                      value={ticketRequest?.description}
                      onChange={ticketChangeHandle}
                      name="description"
                      id=""
                      cols="30"
                      rows="5"
                      class="form-control"
                    ></textarea>
                  </div> */}
                {/* <!-- Attachment --> */}
                {/* <div class="col-12 mb-3">
                  <div>
                    <label htmlFor="attachment">Attachment</label>
                    <div className="border border-dotted text-center p-5">
                      <label
                        htmlFor="fileInput"
                        className="text-decoration-none"
                      >
                        <i className="fa fa-cloud-arrow-up"></i>Drop files to
                        attach or browse
                      </label>
                      <input
                        type="file"
                        id="fileInput"
                        accept="image/png, image/jpeg"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      {attachmentId?.name !== undefined &&
                        attachmentId?.name !== null && (
                          <p>Selected file: {attachmentId?.name}</p>
                        )}
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ width: "80px", height: "50px" }}
            variant="secondary"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            style={{ width: "80px", height: "50px" }}
            variant="primary"
            onClick={createNewToken}
          >
            Create
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
